import React from 'react'
import classnames from 'classnames'
import { Action } from '@foodsby/nutrient'
import { ADD_FAVORITE, DELETE_FAVORITE } from '../../redux/modules/favorite'

const Favorite = ({
  id,
  addFavoriteStart,
  deleteFavoriteStart,
  menuId,
  favoriteLoading,
  classNames,
}) => {
  return (
    <div className={classnames(classNames)}>
      {favoriteLoading && favoriteLoading.action === ADD_FAVORITE ? (
        <Action className="link">
          <i className="icon icon-star-full" />
        </Action>
      ) : favoriteLoading && favoriteLoading.action === DELETE_FAVORITE ? (
        <Action className="link">
          <i className="icon icon-star-empty" />
        </Action>
      ) : deleteFavoriteStart ? (
        <Action
          className="link"
          onClick={evt => {
            evt.preventDefault()
            deleteFavoriteStart(id)
          }}
        >
          <i className="icon icon-star-full" />
        </Action>
      ) : addFavoriteStart ? (
        <Action
          onClick={evt => {
            evt.preventDefault()
            addFavoriteStart(id, menuId)
          }}
        >
          <i className="icon icon-star-empty" />
        </Action>
      ) : null}
    </div>
  )
}
export default Favorite
